import React from "react";

/* eslint-disable max-len */
export default function AdminLicenseIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <defs>
                <clipPath id="a">
                    <path
                        data-name="\u9577\u65B9\u5F62 1706"
                        fill="#9c9c9c"
                        d="M0 0H23V17.308H0z"
                    />
                </clipPath>
            </defs>
            <g data-name="\u30B0\u30EB\u30FC\u30D7 555">
                <g
                    data-name="\u30B0\u30EB\u30FC\u30D7 521"
                    transform="translate(-40 -515) translate(43.5 521.35)"
                    clipPath="url(#a)"
                    fill="#9c9c9c"
                >
                    <path
                        data-name="\u30D1\u30B9 8137"
                        d="M0 5.75v9.961a1.751 1.751 0 001.673 1.818h19.654A1.751 1.751 0 0023 15.711V5.75zm20.125 7.933a.694.694 0 01-.663.721h-4.424a.694.694 0 01-.663-.721V8.875a.694.694 0 01.663-.721h4.423a.694.694 0 01.663.721z"
                        transform="translate(0 -.221)"
                    />
                    <path
                        data-name="\u9577\u65B9\u5F62 1705"
                        transform="translate(15.702 9.375)"
                        d="M0 0H3.096V3.365H0z"
                    />
                    <path
                        data-name="\u30D1\u30B9 8138"
                        d="M23 1.818A1.751 1.751 0 0021.327 0H1.673A1.751 1.751 0 000 1.818v2.269h23z"
                    />
                </g>
            </g>
        </svg>
    );
}
